package ru.villawonka.app.presentation.screens.photoSlider.compose

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.PageSize
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.material.TopAppBar
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource
import kotlinx.coroutines.launch
import ru.villawonka.app.getTelegram
import ru.villawonka.app.presentation.design.components.AppOutlinedIconButton
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.surfaceLow
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_close_24

class PhotoSliderScreen(
    private val initialPage: Int,
    private val photos: List<String>
) : Screen {

    @Composable
    override fun Content() {
        val coroutineScope = rememberCoroutineScope()
        var selectedIndex by remember { mutableStateOf(0) }
        val pagerState = rememberPagerState(
            initialPage = initialPage,
            pageCount = { photos.size }
        )

        Box(
            modifier = Modifier
                .background(MaterialTheme.colors.surfaceLow)
                .fillMaxSize()
        ) {
            HorizontalPager(
                state = pagerState,
                pageSize = PageSize.Fill,
                modifier = Modifier.fillMaxSize()
            ) { page ->
                selectedIndex = page
                KamelImage(
                    resource = { asyncPainterResource(photos[page]) },
                    contentDescription = null,
                    onLoading = { CircularProgressIndicator({it}) },
                    modifier = Modifier.fillMaxWidth()
                )
            }
            Row(
                modifier = Modifier
                    .horizontalScroll(rememberScrollState())
                    .fillMaxWidth()
                    .padding(16.dp)
                    .align(Alignment.BottomCenter)
            ) {
                photos.forEachIndexed { index, item ->

                    KamelImage(
                        resource = { asyncPainterResource(item) },
                        contentDescription = null,
                        contentScale = ContentScale.Crop,
                        onLoading = { CircularProgressIndicator({it}) },
                        modifier = Modifier
                            .size(
                                width = 60.dp,
                                height = 86.dp
                            )
                            .clip(RoundedCornerShape(4.dp))
                            .clickable {
                                coroutineScope.launch {
                                    pagerState.animateScrollToPage(page = index)
                                }
                            }
                    )
                    AppSpacer(8.dp)
                }
            }
        }
        TopAppBarView()
    }

    @Composable
    private fun TopAppBarView() {
        val navigator = LocalNavigator.current

        getTelegram()?.setBackButtonVisible(true) ?: TopAppBar(
            actions = {
                AppOutlinedIconButton(
                    iconRes = Res.drawable.ic_close_24,
                    bordered = false,
                    onClick = {
                        navigator?.pop()
                    }
                )
            },
            title = {},
            backgroundColor = Color.Transparent
        )
    }
}